/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Used_GoodInputs */

const en_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used - Good`)
};

const es_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usado - Bueno`)
};

const fr_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Occasion - Bon`)
};

const de_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebraucht - Gut`)
};

const ja_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中古 - 良い`)
};

const zh_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二手 - 良好`)
};

const ar_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستعمل - جيد`)
};

const id_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekas - Baik`)
};

const it_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usato - Buono`)
};

const ru_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Б/У - Хорошее`)
};

const pt_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usado - Bom`)
};

const ko_val_used_good = /** @type {(inputs: Val_Used_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중고 - 좋음`)
};

/**
* | output |
* | --- |
* | "Used - Good" |
*
* @param {Val_Used_GoodInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_used_good = /** @type {((inputs?: Val_Used_GoodInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Used_GoodInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_used_good(inputs)
	if (locale === "es") return es_val_used_good(inputs)
	if (locale === "fr") return fr_val_used_good(inputs)
	if (locale === "de") return de_val_used_good(inputs)
	if (locale === "ja") return ja_val_used_good(inputs)
	if (locale === "zh") return zh_val_used_good(inputs)
	if (locale === "ar") return ar_val_used_good(inputs)
	if (locale === "id") return id_val_used_good(inputs)
	if (locale === "it") return it_val_used_good(inputs)
	if (locale === "ru") return ru_val_used_good(inputs)
	if (locale === "pt") return pt_val_used_good(inputs)
	return ko_val_used_good(inputs)
});